// Files Data Base — the module's vocabulary. Ids here are the CHECK values in
// sql/2026-09-12-files-p1-package.sql (files_assets.kind / .status, files_links.entity_type,
// files_cl_candidates.source) and in sql/2026-09-14-files-photo-actions-v1.sql
// (files_assets.decision); change them there first, never here alone.

export const FILES_PORTAL_ID = 'files';       // user_portal_permissions.portal_id
export const FILES_TAB = 'filesBank';         // uiStore tab id, routed in TabRouter.js
export const FILES_BUCKET = 'files-bank';     // the private bucket (BLOCK 1)
export const FILES_DISPLAY_NAME = 'Files Database';

// The two screens the shell offers. `?files_view=` mirrors the key.
export const FILES_VIEWS = [
  { key: 'all',    label: 'All files' },
  { key: 'photos', label: 'Model photos' },
];

// "Where each kind goes" — the prototype's explainer card, and the routing rule the drop
// obeys. `live` kinds attach themselves; the others are recognised and parked (brief §9.2).
export const FILE_KINDS = [
  { id: 'colour_sheet', label: 'Colour sample sheet', dest: 'to the development card', live: true,  tone: 'amber' },
  { id: 'model_photo',  label: 'Model photo',         dest: 'to the model gallery',    live: true,  tone: 'amber' },
  { id: 'order_sheet',  label: 'Order sheet',         dest: 'to Orders — later',       live: false, tone: 'mute'  },
  { id: 'tech_drawing', label: 'Technical drawing',   dest: 'to the development card — later', live: false, tone: 'mute' },
  { id: 'document',     label: 'Document',            dest: 'parked',                  live: false, tone: 'mute'  },
  { id: 'unknown',      label: 'Unrecognised',        dest: 'needs you',               live: false, tone: 'warn'  },
];
export const KIND_BY_ID = Object.fromEntries(FILE_KINDS.map((k) => [k.id, k]));
export const kindLabel = (id) => (KIND_BY_ID[id] || KIND_BY_ID.unknown).label;

export const FILE_STATUS = {
  attached:     { label: 'Attached',    tone: 'ok'   },
  needs_review: { label: 'Needs you',   tone: 'warn' },
  parked:       { label: 'Parked',      tone: 'mute' },
};

// The PERSON's decision on a photo — files_assets.decision, a column kept apart from the
// machine's `status` above (attached / needs you / parked is what the system knows; ordered /
// canceled / not relevant is what a person decided). No other file may spell these ids.
export const PHOTO_DECISIONS = [
  { id: 'ordered',    label: 'Ordered',      hint: 'an order was placed',   tone: 'ok'   },
  { id: 'canceled',   label: 'Canceled',     hint: 'dropped, kept on file', tone: 'stop' },
  { id: 'irrelevant', label: 'Not relevant', hint: 'not for this model',    tone: 'mute' },
];
export const DECISION_BY_ID = Object.fromEntries(PHOTO_DECISIONS.map((d) => [d.id, d]));

export const ENTITY_TYPES = ['development', 'model'];

export const CL_LINK_SOURCES = ['sheet_filename', 'sheet_body', 'photo_filename', 'folder_pointer'];

// Client-side size guard — the bucket refuses above 25 MB anyway; this gives a sentence
// instead of a storage error (the same shape the five existing 10 MB guards use).
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
